document.addEventListener('DOMContentLoaded', () => {
	const slideUntilDesktop =    document.querySelectorAll('.slide-until-desktop');
	// const testimonial_carousel =    document.querySelectorAll('.testimonial-carousel');
	// const slider =    document.querySelectorAll('.slider__active');

	if (slideUntilDesktop) {
		const Flickity = require('flickity');

		Array.from(slideUntilDesktop).map(el => new Flickity(el, {
			pageDots: false,
			autoPlay: 1500,
			watchCSS: true,
			cellAlign:  'left',
			prevNextButtons: false,
			imagesLoaded: true,
		}));
	}
});